<tile [defaultImage]="headerListImage" [link]="canViewCv ? ['/cv/', cv.Id] : null">
  <div
    class="container cv-list-element-progress-{{ cv.Progress }} flex flex-col flex-between-stretch"
    data-test-id="cv-list-element-container"
    id="cv-id-{{ cv.Id }}"
  >
    <div class="body">
      <div class="body-header flex flex-between-center">
        <div class="labels" data-test-id="cv-list-element-label">
          @if (cv.IsSent) {
            <span class="pill" color="accent" data-test-id="cv-list-element-label-send-pill">Sent to 7N</span>
          }
          @if (!cv.IsSent) {
            <span class="pill" color="alternative" data-test-id="cv-list-element-label-draft-pill">Draft</span>
          }
          <span class="language pill" data-test-id="cv-list-element-label-language-pill">
            {{ cvLanguage.LanguageName }}
          </span>
        </div>
        <div class="options-menu">
          @if (showMenuButton$ | async) {
            <button
              [disableRipple]="true"
              [matMenuTriggerFor]="menu"
              (click)="stopPropagation($event)"
              class="options-menu-opener color-on-hover"
              color="primary"
              data-test-id="cv-list-element-menu-button"
              mat-icon-button
            >
              <mat-icon class="no-transition" svgIcon="dots"></mat-icon>
            </button>
          }
          <mat-menu
            #menu="matMenu"
            class="dropdown-button-panel primary"
            data-test-id="cv-list-element-menu-items-container"
          >
            <button
              [disableRipple]="true"
              (click)="editCv()"
              *authCan="cvEditFeature"
              class="cv-edit-button"
              data-test-id="cv-list-element-menu-edit-option"
              mat-menu-item
            >
              Edit
            </button>
            <button
              [disableRipple]="true"
              (click)="showRenameDialog()"
              *authCan="cvRenameFeature"
              class="cv-rename-button"
              data-test-id="cv-list-element-menu-rename-option"
              mat-menu-item
            >
              Rename
            </button>
            <button
              [disableRipple]="true"
              (click)="duplicateCv()"
              *authCan="cvDuplicateFeature"
              class="cv-copy-button"
              data-test-id="cv-list-element-menu-duplicate-option"
              mat-menu-item
            >
              Duplicate
            </button>
            <button
              [disableRipple]="true"
              (click)="deleteCv()"
              *authCan="cvDeleteFeature"
              class="cv-remove-button"
              color="warn"
              data-test-id="cv-list-element-menu-delete-option"
              mat-menu-item
            >
              Delete
            </button>
          </mat-menu>
        </div>
      </div>
      <h3 class="cv-name" data-test-id="cv-list-element-cv-name-container">
        @if (canViewCv | async) {
          <a
            [routerLink]="['/cv/', cv.Id]"
            (click)="stopPropagation($event)"
            data-test-id="cv-list-element-cv-name-container-link"
          >
            {{ cv.Name }}
          </a>
        }
        @if (!(canViewCv | async)) {
          <span data-test-id="cv-list-element-cv-name-container-noLink">{{ cv.Name }}</span>
        }
      </h3>
      <p class="title" data-test-id="cv-list-element-cv-jobTitle">
        {{ cv.Title || 'No job title' }}
      </p>
    </div>

    <div class="footer" data-test-id="cv-list-element-footer">
      <progress-bar [progress]="cv.Progress" #progressBar label="CV strength">
        <div class="main-info flex flex-full">
          <h5 class="progress-header font-bold">
            {{ progressBar.label }}:
            <span [value]="progressBar.progress" numberScroll>{{ progressBar.progress }}</span>
            %
          </h5>
        </div>
      </progress-bar>
      <div class="created">
        <mat-icon svgIcon="calendar_big"></mat-icon>
        <span class="created-text">Last modified {{ cv.LastModifiedDate | defaultDate: 'day' : true : false }}</span>
      </div>
    </div>
  </div>
</tile>
